import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DataTableConfig } from 'src/app/shared/table/table-interface';
import { CommonServiceLayerService, RequestPayLoadFormat } from 'src/app/services/common-service-layer.service';
import { SharedService } from 'src/app/shared/shared.service';
import { AlertService } from 'src/app/shared/alert.service';
import { Config } from 'src/app/config/config';
import { LayoutService } from 'src/app/layout/layout.service';


@Component({
  selector: 'app-map-analytic-loader',
  templateUrl: './map-analytic-loader.component.html',
  styleUrls: ['./map-analytic-loader.component.scss']
})
export class MapAnalyticLoaderComponent implements OnInit {

  @Input() tableData;
  @Input() hiddenTable;
  @Output() hiddenTableStatus: EventEmitter<any>;
  public tableConfigData: DataTableConfig;
  public backBtn = true;
  public markers: any;
  public lat = 11.0168; // To Display default latitude
  public lng = 76.9558;
  public geoJsonObject: any;
  constructor(
    public modalService: LayoutService,
    private http: CommonServiceLayerService,
    public sharedService: SharedService,
    public alert: AlertService
  ) { }

  ngOnInit() {
    this.setTableConfigData();
    this.loadGeoJson();
    if (this.tableData) {
      this.formatTableDataAnalytics(this.tableData);
    } else {
      this.getTableData();
    }
  }
  getTableData() {
    try {
      const payLoad: any = {};
      const request: RequestPayLoadFormat = {
        api: 'analyticsReportLoad',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(res => {
        if (res.status) {
          this.tableData = res;
          this.hiddenTable = false;
          this.formatTableDataAnalytics(this.tableData);
        } else {
          this.sharedService.serviceErrorMessage(res.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  // marker Click event
  loadGeoJson() {
    try {
      const request: RequestPayLoadFormat = {
        api: 'dubaiDMGeoJson',
        method: 'get',
        loader: true,
        type: 'JSON',
        hideErrorMessage: false
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response) {
          this.geoJsonObject = response;
        } else {
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  styleFunc(feature) {
    return ({
      clickable: false,
      fillColor: '#50a3ea', // feature.getProperty('color'),
      strokeWeight: 1,
      stroke: '#50a3ea'
    });
  }
  formatTableDataAnalytics(data) {
    this.tableConfigData.tableData = data.data.tableData;
    // this.hiddenTable = false;
    // this.hiddenTableStatus.emit(this.hiddenTable);
  }
  setTableConfigData() {
    try {
      this.tableConfigData = {
        dtOptions: {
          maxRows: 10,
          searchButton: true,
          columnSearch: false,
          displayOptions: true,
          headerLabel: 'name',
        },
        actions: [
          { type: 'view', icon: 'fa fa-eye', title: 'View' },
          {
            type: 'delete', icon: 'fa fa-trash', title: 'Delete', class: 'btn-danger'
          }
        ],
      };
    } catch (error) {
      Config.logger(error);
    }
  }
  markerClicked(m, event) {
    m.isClicked = !m.isClicked;
    Config.logger(event);
  }
  tableAction(event) {
    if (event.key === 'view') {
      try {
        this.markers = undefined;
        this.markers = event.obj.mapOverLays;
        this.backBtn = false;
        this.hiddenTable = !this.hiddenTable;
      } catch (error) {
        Config.logger(error);
      }
    } else if (event.key === 'delete') {
      try {
      } catch (error) {
        Config.logger(error);
      }
    }
  }


}
